exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".cvat-projects-search-tooltip span,.cvat-tasks-search-tooltip span{color:white}.cvat-projects-search-tooltip strong::after,.cvat-tasks-search-tooltip strong::after{content:' - '}\n", ""]);
